import { render, staticRenderFns } from "./IsHotmartForMeForm.vue?vue&type=template&id=40471420&scoped=true"
var script = {}
import style0 from "./IsHotmartForMeForm.scss?vue&type=style&index=0&id=40471420&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40471420",
  null
  
)

export default component.exports